(function() {
    // Poll for jQuery to come into existance
    var checkReady = function(callback) {
        if (window.jQuery) {
            callback(jQuery);
        }
        else {
            window.setTimeout(function() { checkReady(callback); }, 20);
        }
    };

    // Start polling...
    checkReady(function($) {
        $( "#customer_login" ).on( "submit", function( event ) {
            setCookie('customer_login_email', $('#customer_email').val(), 5);
        });
      
        $(function() {

              // Reveals the error message and ties it to the form fields for
              // screen-reader users: sets aria-invalid / aria-describedby on the
              // inputs and moves focus to the first errored field. Called only
              // once, with the FINAL message, so the screen reader announces a
              // single error (no "invalid email or password" -> "not activated"
              // flash).
              var revealLoginError = function() {
                  var $message = $('#customer_login_error');
                  if (!$message.length) {
                      return;
                  }
                  $message
                      .removeAttr('hidden')
                      .css({
                          'visibility': 'visible',
                          'height': 'auto',
                          'margin': '',
                          'padding': '',
                          'overflow': 'hidden'
                      })
                      .show();

                  var $fields = $('#customer_email, #customer_password');
                  $fields.attr('aria-invalid', 'true');
                  $fields.attr('aria-describedby', 'customer_login_error');

                  var firstField = document.getElementById('customer_email');
                  if (firstField) {
                      firstField.focus();
                  }
              };

              // Replaces the error text with the activation message.
              var setActivationMessage = function(message) {
                  var $errors = $('#customer_login_error .errors');
                  if (!$errors.length) {
                      $errors = $('<div class="errors"><ul><li></li></ul></div>');
                      $('#customer_login_error').append($errors);
                  }
                  if (!$errors.find('ul > li').length) {
                      $errors.find('ul').append('<li></li>');
                  }
                  // Use only the activation message; drop any server-rendered
                  // "invalid email or password" so a single, correct error shows.
                  $errors.find('ul').html('<li></li>');
                  $errors.find('ul > li').text(message);
              };

              var hasServerError = $('#customer_login_error .errors li').length > 0;
              var email = getCookie('customer_login_email');

              // No pending activation check: just reveal the server error (if any).
              if (!email) {
                  if (hasServerError) {
                      revealLoginError();
                  }
                  return;
              }

              var post_data = {
                email: email
              };

              $.ajax({
                  url: 'https://a1.seekinghealth.com/check-account-login.php',
                  type: 'POST',
                  data: post_data,
                  dataType: 'html',
                  success: function(data) {
                      if (data) {
                        data = JSON.parse(data);
                        if (data.error == 0) {
                            // Activation message overrides the server error.
                            setActivationMessage(data.message);
                        }
                        console.debug(data);
                      }
                  },
                  error: function() {
                      //alert("Something went wrong!");
                  },
                  complete: function() {
                      setCookie('customer_login_email', '', 1);
                      // Reveal once, after the final message is decided. If the
                      // AJAX overrode the text it shows the activation message;
                      // otherwise it falls back to the server error.
                      if ($('#customer_login_error .errors li').length > 0) {
                          revealLoginError();
                      }
                  }
              });

        });
    });
})();